/**
 * The flag an ordering link asked for (`?tagId=`), remembered for the session.
 *
 * The link is opened once, but the customer then navigates menu → item → cart →
 * order, and React Router does not carry the query string across those steps. So
 * the id has to outlive the URL it arrived on, or the order would be placed
 * under a different flag than the prices the customer just read.
 *
 * Scoped per location: a flag from one venue must never price another's menu.
 * Stored in a cookie with the same lifetime as the cart, so a stale flag can't
 * outlive the visit it belonged to.
 */
const TAG_ID_COOKIE_PREFIX = "tagId_";

export const getTagIdCookieName = (locationId: string) =>
  `${TAG_ID_COOKIE_PREFIX}${locationId}`;

/**
 * The flag to ask the server for: the link's, else the one remembered from
 * earlier in this visit.
 */
export const resolveRequestedTagId = (
  urlTagId: string | null | undefined,
  storedTagId: unknown,
): string | undefined =>
  urlTagId ||
  (typeof storedTagId === "string" && storedTagId ? storedTagId : undefined);
